import { css } from '@emotion/core'

export const styles = {
  children: css`
    /* width: 100vw; */
    /* min-height: 100vh; */
    /* 
    background: linear-gradient(90deg, white 20px, transparent 1%) center,
      linear-gradient(white 20px, transparent 1%) center, rgba(48, 127, 186, 0.05);
    background-size: 22px 22px; */
  `,
}
